export default {_name:'button.fab',module:'Field',view:'Element/Button/Fab',options:{disabled:true,classes:['end'],md:3}}